import React, { useEffect, useState } from 'react';
import { GoogleAuthProvider, getAuth, signInWithPopup, signOut, onAuthStateChanged } from 'firebase/auth'
import { toast, ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { addUser, removeUser } from '../redux/shopSlice';
import { Link, useNavigate } from 'react-router-dom';
import { addDoc, getDocs, query, where } from 'firebase/firestore/lite';

import { userData } from '../firebase.config';


function LogIn() {

  /*     const [user, setUser] = useState(null);
    const auth = getAuth();
  
    useEffect(() => {
      // Check if the user is already signed in
      const unsubscribe = onAuthStateChanged(auth, (user) => {
        if (user) {
          setUser(user);
        }
      });
  
      return unsubscribe;
    }, [auth]);
  
    useEffect(() => {
      // Persist the user session when the user signs in
      if (user) {
        sessionStorage.setItem('user', JSON.stringify(user));
      } else {
        sessionStorage.removeItem('user');
      }
    }, [user]);
  
    useEffect(() => {
      // Check for a persisted user session when the component mounts
      const persistedUser = sessionStorage.getItem('user');
      if (persistedUser) {
        setUser(JSON.parse(persistedUser));
      }
    }, []);
  
    
    
      
      const dispatch = useDispatch()
      const navigate = useNavigate()
      const provider = new GoogleAuthProvider();
      const handleGoogleSignin = (e)=>{
          e.preventDefault()
          signInWithPopup(auth, provider).then((result)=>{
              const credential = GoogleAuthProvider.credentialFromResult(result)
              const user = result.user;
  
              // Set the user object to state and localStorage
              localStorage.setItem('user', JSON.stringify(user));
              
              dispatch(addUser({
                  _id: user.uid,
                  name: user.displayName,
                  email: user.email,
                  image: user.photoURL
              }))
              setTimeout(()=>{
                  navigate("/")
              }, 1000)
          }).catch((error)=>{
              const credential = GoogleAuthProvider.credentialFromError(error)
              console.log(error)
          })
      }
  
      const handleSignOut = ()=> {
          signOut(auth).then(()=>{
              dispatch(removeUser())
              setUser(null);
              toast.success('Logged Out SuccessFully')
          }).catch(error => {
              console.log('Error signing out: ', error);
            });
      }
      const userInfo = useSelector((state)=> state.shopsyReducer.userInfo) */

  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const auth = getAuth();
  const userInfo = useSelector((state) => state.shopsyReducer.userInfo);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        // User is signed in, set the user object to state and localStorage
        localStorage.setItem('user', JSON.stringify(user));
        dispatch(
          addUser({
            _id: user.uid,
            name: user.displayName,
            email: user.email,
            image: user.photoURL,
          })
        );
      } else {
        // User is signed out, set the user object to null in state and localStorage
        localStorage.removeItem('user');
        dispatch(removeUser());
      }
      setIsLoading(false);
    });

    // Unsubscribe from the listener when the component unmounts
    return () => unsubscribe();
  }, [auth, dispatch]);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem('user'));
    if (storedUser) {
      // There's a user object in localStorage, set the user object to state
      dispatch(
        addUser({
          _id: storedUser.uid,
          name: storedUser.displayName,
          email: storedUser.email,
          image: storedUser.photoURL,
        })
      );
    }
    setIsLoading(false);
  }, [dispatch]);

  const provider = new GoogleAuthProvider()
  const handleGoogleSignin = (e) => {
    e.preventDefault();
    signInWithPopup(auth, provider)
      .then((result) => {
        /* const credential = GoogleAuthProvider.credentialFromResult(result); */
        const user = result.user;


        const addUser = async () => {
          /* const userData = collection(db,"users") */
          const querySnapshot = await getDocs(query(userData, where("uid", "==", user.uid)));

          if (querySnapshot.size > 0) {
            console.log("User already exists with id:", user.uid);
            return;
          }

          try {
            await addDoc(userData, {
              uid: user.uid,
              name: user.displayName,
              email: user.email,
              image: user.photoURL,
              cart: [],
              orders: [],
              address: { name: "", mobile: "", pin: "", house: "", street: "", landmark: "", city: "", state: "" },
            })

            console.log('Created :', userData)
          } catch (error) {
            console.error("Error while creating document: ", error);
          }
        };



        // Set the user object to state and localStorage
        localStorage.setItem('user', JSON.stringify(user));
        dispatch(
          addUser({
            _id: user.uid,
            name: user.displayName,
            email: user.email,
            image: user.photoURL,
          })
        );

        setTimeout(() => {
          navigate('/');
        }, 1000);
      })
      .catch((error) => {
        /* const credential = GoogleAuthProvider.credentialFromError(error); */
        console.log(error);
      });
  };

  const handleSignOut = () => {
    signOut(auth)
      .then(() => {
        // Remove the user object from state and localStorage
        localStorage.removeItem('user');
        dispatch(removeUser());
        toast.success('Logged Out SuccessFully');
      })
      .catch((error) => {
        console.log('Error signing out: ', error);
      });
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div className='w-full h-[90vh] flex flex-col items-center justify-center pb-20 my-auto '>
      
      <div className='relative'>
        {userInfo ?
          <div className=''>
            <img className='lg:w-24 w-[4.5rem] rounded-full p-0.5 lg:mr-[29vw] mr-[70vw] mb-[-2rem] bg-slate-900 border-purple-300 border-2 lg:mb-[-3rem] z-10'
              src={userInfo.image} alt="userProfile" />
          </div>
          : ""}
      </div>
      {userInfo?
      <div className='bg-slate-900 h-18 lg:w-[35vw] w-[90vw] rounded-t-3xl border-t-2 border-purple-300'><p className='font-bold lg:text-xl  text-center text-purple-300 font-bodyFont my-6'><span className='text-lg font-semibold'>{userInfo ? "Hello, " : ""}</span>{userInfo ? userInfo.name : ""}</p></div>
      :""}
      {/* <div>
            { userInfo ?
            <Link to={'/orders'}>
             <button
                 className='bg-slate-900 text-purple-100 text-base py-3 px-8 tracking-wide
                rounded-md hover:bg-slate-800 duration-300'>
                Orders
            </button>
            </Link>: ""}
            </div>

            <div>
            { userInfo ?
            <Link to={'/address'}>
             <button
                 className='bg-slate-900 text-purple-100 text-base py-3 px-7 tracking-wide
                rounded-md hover:bg-slate-800 duration-300'>
                Address
            </button>
            </Link>: ""}
            </div>

            <div>
            { userInfo ?
            <Link to={'/request-listing'}>
             <button
                 className='bg-slate-900 text-purple-100 text-base py-3 px-7 tracking-wide
                rounded-md hover:bg-slate-800 duration-300'>
                Request
            </button>
            </Link>: ""}
            </div> */}


        {userInfo ?

          ""
          :
          <div className='w-full flex items-center justify-center gap-5 my-auto'>
          <div onClick={handleGoogleSignin}
            className='text-base w-56 h-14 -tracking-wide border-[1px] border-slate-400 rounded-md flex 
                items-center justify-center gap-2 py-2 hover:border-purple-900'>
            <img className='w-10' src="https://img.freepik.com/free-icon/search_318-265146.jpg" alt="GoogleLogo" />
            <span className="text-sm text-slate-900"> Sign in with Google</span>
          </div>

        </div>
        }
        {/* { userInfo ? <button onClick={handleSignOut}
                 className='bg-slate-900 text-purple-100 text-base py-3 px-6 tracking-wide
                rounded-md hover:bg-slate-800 duration-300'>
                Sign out
            </button>: ""} */}
      {userInfo ?
        <div>

          <div class='bg-slate-900 text-purple-100 text-base py-2 px-2 tracking-wide rounded-b-md duration-300 flex-col lg:w-[35vw] w-[90vw] border-t-2 border-purple-300'>

            <Link to={'/orders'}>
              <div className='hover:text-purple-200 bg-slate-900 text-purple-200 text-base py-3 px-3 w-full tracking-wide rounded-md hover:bg-slate-950 duration-300 flex justify-between'>
                <span>Orders</span>  <span>&gt;</span>
              </div>
            </Link>
            <hr class='opacity-50 w-full my-1' />
            <Link to={'/address'}>
              <div className='hover:text-purple-200 bg-slate-900 text-purple-200 text-base py-3 px-3 w-full tracking-wide rounded-md hover:bg-slate-950 duration-300 flex justify-between'>
                <span>Address</span>  <span>&gt;</span>
              </div>
            </Link>
            <hr class='opacity-50 w-full my-1' />
            <Link to={'/request-listing'}>
              <div className='hover:text-purple-200 bg-slate-900 text-purple-200 text-base py-3 px-3 w-full tracking-wide rounded-md hover:bg-slate-950 duration-300 flex justify-between'>
                <span>Request</span>  <span>&gt;</span>
              </div>
            </Link>
            <hr class='opacity-50 w-full my-1' />
            <Link to={'/support'}>
              <div className='hover:text-purple-200 bg-slate-900 text-purple-200 text-base py-3 px-3 w-full tracking-wide rounded-md hover:bg-slate-950 duration-300 flex justify-between'>
                <span>Support</span>  <span>&gt;</span>
              </div>
            </Link>
            <hr class='opacity-50 w-full my-1' />
            <div onClick={handleSignOut}>
              <div className='hover:text-purple-200 bg-slate-900 text-purple-200 text-base py-3 px-3 w-full tracking-wide rounded-md hover:bg-slate-950 duration-300 flex justify-between'>
                <span>Sign out</span>  <span>&gt;</span>
              </div>


            </div>
          </div>
        </div> : ""}
      {/* <div className='w-full flex items-center justify-center gap-5'>
            <div className='text-base w-56 h-12-tracking-wide border-[1px] border-slate-400 rounded-md flex 
                items-center justify-center gap-2 py-2 hover:border-purple-900'>
                <img className='w-10' src="https://cdn-icons-png.flaticon.com/512/25/25231.png" alt="GoogleLogo" />
                <span className="text-sm text-slate-900"> Sign in with GitHub</span>
            </div>
            <button className='bg-slate-900 text-purple-100 text-base py-3 px-6 tracking-wide
                rounded-md hover:bg-slate-800 duration-300'>
                Sign out
            </button>
        </div>
        <div className='w-full flex items-center justify-center gap-5'>
            <div className='text-base w-56 h-12-tracking-wide border-[1px] border-slate-400 rounded-md flex 
                items-center justify-center gap-2 py-2 hover:border-purple-900'>
                <img className='w-10' src="https://cdn.iconscout.com/icon/free/png-256/metamask-2728406-2261817.png" alt="GoogleLogo" />
                <span className="text-sm text-slate-900"> Sign in with Meta</span>
            </div>
            <button className='bg-slate-900 text-purple-100 text-base py-3 px-6 tracking-wide
                rounded-md hover:bg-slate-800 duration-300'>
                Sign out
            </button> 
        </div>*/}

      {userInfo && userInfo.email === "shopsyiteam@gmail.com" ?
        <Link to="/admin" className='text-purple-700'>AdminPannel</Link>
        : ""
      }

      <ToastContainer
        position="top-left"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        toastClassName="custom-toast-background"
      />
    </div>
  )
}

export default LogIn